import { FC, useMemo } from "react";
import { MenuProps } from "../types";
import { useStoreState } from "../store/useStore";
import { useTranslations } from "use-intl";
import { stylesText } from "../styles";
import ArrowIcon from "../../assets/header/arrow.svg?react";
import { Languages, LanguagesType } from "../../types";

const H5Menu: FC<{
  menus: MenuProps;
  changePages: (label: string) => void;
  changeRoute?: (route: string) => void;
}> = (props) => {
  const { menus, changePages, changeRoute } = props;

  const { localeLink, theme, locale, position } = useStoreState();

  const t = useTranslations("header");

  const childRoute = (url: string, basePath: string) => {
    return `/${basePath}${localeLink}/${url}`;
  };

  const mode = useMemo(() => {
    if (position === "sticky") {
      return "light";
    } else {
      return theme;
    }
  }, [position, theme]);

  const changeRouter = (item: MenuProps, e: React.MouseEvent<HTMLAnchorElement>) => {
    if (changeRoute) {
      e.preventDefault();
      if (!item.items) {
        if (item.basePath) {
          changeRoute(`/${item.basePath}${localeLink}/${item.url}`);
        } else {
          changeRoute(`${localeLink}/${item.url}`);
        }
      }
    }
  };

  return (
    <div
      className="flex items-start flex-col w-[calc(100%_-_16px)]"
      onClick={() => changePages(menus.label as string)}
    >
      <div className="flex h-[24px] items-center text-[14px] cursor-pointer justify-between w-full">
        <i className={`flex items-center text-[16px] ${stylesText({ mode: mode })}`}>
          {menus.icon && <menus.icon className={stylesText({ mode: mode })} />}
          <i className="ml-[12px] not-italic">
            {
              Languages[locale as LanguagesType].header[
                menus.label as keyof (typeof Languages)[LanguagesType]["header"]
              ]
            }
          </i>
        </i>
        <ArrowIcon
          className={`group-hover:rotate-180 ml-[2px] w-[20px] h-[20px] ${stylesText({
            mode: mode
          })}`}
        />
      </div>
      {menus.drawer && (
        <div>
          {menus.items?.map((item, index) => {
            return (
              <a
                href={
                  item.basePath ? childRoute(item.url!, item.basePath) : `${localeLink}/${item.url}`
                }
                key={index}
                onClick={(e) => changeRouter(item, e)}
              >
                <div className={`flex items-center w-[360px] px-[40px] cursor-pointer`}>
                  <div className="flex flex-col mt-[24px]">
                    <span
                      className={`text-[14px] flex items-center leading-[20px] ${stylesText({
                        mode: mode
                      })}`}
                    >
                      {t(item.label)}
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default H5Menu;
